// Предупреждения при переключении режимов расчёта (решение USER 2026-07-21,
// продолжение annul-предупреждения): пользователи включают ручной режим
// «просто вписать цифру», не понимая последствий — блокирующий confirm в
// момент переключения с конкретикой, что именно перестанет/начнёт работать.
//
// Два направления:
//  - включение РУЧНОГО режима: движок отключается, панель сохраняется как есть;
//  - включение АВТОРАСЧЁТА: движок пересчитает и ЗАМЕНИТ ручные цифры.
//
// ВАЖНО (XSS): результат уходит в $confirm({ html }) — интерполируются
// только $t-строки, никаких пользовательских данных.

export function buildManualModeOnWarning({ context, prolongsCount, t }) {
  const returnHintKey = context === "create"
    ? "bookings.manual_on_return_create"
    : "bookings.manual_on_return_edit";

  const lines = [
    `<p>${t("bookings.manual_on_intro")}</p>`,
    "<ul style=\"text-align:left\">",
    `<li>${t("bookings.manual_on_point_prices")}</li>`,
    `<li>${t("bookings.manual_on_point_dates")}</li>`,
    `<li>${t("bookings.manual_on_point_asis")}</li>`,
    "</ul>",
  ];
  if (prolongsCount > 0) {
    lines.push(`<p class="warning--text font-weight-bold">${t("bookings.manual_on_prolongs")}</p>`);
  }
  lines.push(`<p>${t(returnHintKey)}</p>`);
  return lines.join("");
}

export function buildAutoCalcOnWarning({ prolongsCount, t }) {
  const lines = [`<p>${t("bookings.auto_on_text")}</p>`];
  if (prolongsCount > 0) {
    lines.push(`<p>${t("bookings.auto_on_prolongs")}</p>`);
  }
  return lines.join("");
}
